




















































import Vue from 'vue'
import siteNavBar from '@/components/siteNavBar.vue'
import chatFeedback from '@/components/chatFeedback.vue'
import siteFooter from '@/components/siteFooter.vue'
import snackbar from '@/components/snackbar.vue'
import gdpr from '@/components/gdpr.vue'

// @ is an alias to /src

export default Vue.extend({
  name: 'App',
  metaInfo: {
    // Default Page Title
    title: 'tdlab.io',
    // all titles will be injected into this template
    titleTemplate: '%s | TD Lab',
    link: [
      { rel: 'canonical', href: 'https://tdlabio-dev.firebaseapp.com/' }
    ]
  },
  components: {
    siteNavBar,
    chatFeedback,
    siteFooter,
    snackbar,
    gdpr
  },
  data () {
    return {
      json: {}
    }
  }
})
